import { portfolioTypes } from '../types/portfolio'
import portfolioService from 'src/services/portfolio'

export const getAllPortfolioDataSuccess = (data: any) => {
  return {
    type: portfolioTypes.GET_PORTFOLIO_SUCCESS,
    payload: data,
  }
}

export const getAllPortfoliosAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await portfolioService.portfolio()
      dispatch(getAllPortfolioDataSuccess(response.data.data.portfolio))
    } catch (error: any) {
      console.log(error.message)
    }
  }
}
